// extracted by mini-css-extract-plugin
export default {"navwrapper":"Sidemenu_navwrapper__QRo8S","navlink":"Sidemenu_navlink__h+6GQ"};